var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "bold",
    "class": _vm.classCst,
    style: _vm.styleCst,
    on: {
      "click": _vm.showUserManager
    }
  }, [!_vm.clientInfo.first_name ? _c('span', {
    staticClass: "noselect"
  }, [_vm._v(" ID " + _vm._s(_vm.clientInfo.id) + " ")]) : _c('span', {
    staticClass: "noselect"
  }, [_vm._v(" " + _vm._s(_vm.clientInfo.first_name) + " " + _vm._s(_vm.clientInfo.last_name) + " ")])]), _vm.telephone ? _c('span', {
    staticClass: "noselect small"
  }, [_vm._v(" " + _vm._s(_vm.formattedTelephone) + " ")]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }